import React, {Component} from 'react'
import api from '../../utils/api'
import handleError from '../../utils/handleError'
import {translate as tl} from '../../utils/translation'
import date from '../../utils/formatDate'

import Container from '../helpers/Container'

export default class ShopMediamarktProductappointmentStatistic extends Component {
  constructor (props) {
    super(props)

    this.state = {
      data: [],
      rows: [],
      date: new Date()
    }
  }

  async componentDidMount () {
    await this.getData()
  }

  async getData () {
    try {
      const {data: {data, date}} = await api('/shop_mediamarkt/statistic/productappointments', 'GET')
      this.setState({
        data: data,
        date: new Date(date),
        rows: data.reduce((object, row) => {
          Object.keys(row).forEach(key => {
            object[key] = object[key] ? [...object[key], row[key]] : [row[key]]
          })
          return object
        }, {})
      })
    } catch (error) {
      handleError(error, this.props)
    }
  }

  render () {
    return (
      <div>
        <p>{tl('backend_statistics_updated')}: {this.state.date.toLocaleString()}</p>
        <Container title={tl('backend_statistics_title_productappointments')}>
          <table className='table'>
            <thead>
              <tr>
                <th>{tl('backend_field_product')}</th>
                <th>{tl('backend_field_date')}</th>
                <th>{tl('backend_field_count')}</th>
              </tr>
            </thead>
            <tbody>
              {
                this.state.data.map((row, index) => {
                  return (
                    <tr key={index}>
                      <td>{row.product.title}</td>
                      <td>{date(row.date)}</td>
                      <td>{row.count}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
          <div className='clearfix' />
        </Container>
      </div>
    )
  }
}
